import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
import { StandardError } from '@/util/StandardErrors';
import ErrorKey from '@/util/ErrorKey';
import { StoreResponse } from '@/stores/response';
import isEqual from 'lodash/isEqual';

@Module({
  namespaced: true,
  name: 'ErrorStore',
})
export class ErrorStore extends VuexModule {
  private error: StandardError | null = null;

  public get currentError(): StandardError | null {
    return this.error;
  }

  // so that we can see the actual error key in the Vuex devtools
  public get currentErrorCodeString(): string | null {
    return (this.error && ErrorKey[this.error.errorKey]) || null;
  }

  @Mutation
  public setError(error: StandardError | null): void {
    this.error = error;
  }

  @Action
  public dismissError(): void {
    this.context.commit('setError', null);
  }

  @Action
  public dismissStandardError(error: StandardError): void {
    if (isEqual(error, this.error)) {
      this.dismissError();
    }
  }

  @Action
  public dismissErrorOfType(key: ErrorKey): void {
    if (this.error?.errorKey === key) {
      this.dismissError();
    }
  }

  @Action
  public dismissResponseError(response: StoreResponse<any>): void {
    if (isEqual(response.error, this.error)) {
      this.dismissError();
    }
  }
}
